export const updateSolutions = ({ slug, followed, solutions }) => {
  return solutions.map(solution => {
    if (slug === solution.slug) {
      return { ...solution, followed };
    }

    return solution;
  });
};
